<nz-card *ngIf="user" nzTitle="{{user.name}}">
  <form *ngIf="profileForm" nz-form [formGroup]="profileForm" nzLayout="vertical" (ngSubmit)="onSubmit()">
    <div class="input-section">
      <nz-form-item>
        <nz-form-label nzFor="preferredEmail" nzRequired>{{ 'profil.labelEmail' | translate }}</nz-form-label>
        <nz-form-control [nzErrorTip]="preferredEmailErrorTemplate">
          <input nz-input [placeholder]="'profil.labelEmailPlaceholder' | translate" id="preferredEmail"
            formControlName="preferredEmail" (input)="onInput($event)" [nzAutocomplete]="auto" />
          <nz-autocomplete #auto>
            @for (option of optionsDomain; track $index) {
            <nz-auto-option [nzValue]="option">{{ option }}</nz-auto-option>
            }
          </nz-autocomplete>
        </nz-form-control>
      </nz-form-item>

      <nz-form-item>
        <nz-form-label nzFor="langageUser" nzRequired>{{ 'profil.labelLanguage' | translate }}</nz-form-label>
        <nz-radio-group formControlName="langageUser">
          <label nz-radio nzValue="en">English</label>
          <label nz-radio nzValue="fr">Français</label>
          <label nz-radio nzValue="es">Español</label>
          <label nz-radio nzValue="de">Deutsch</label>
          <label nz-radio nzValue="zh">中文</label>
        </nz-radio-group>
      </nz-form-item>
    </div>
    <nz-form-item class="submit-section">
      <nz-form-control>
        <button nz-button nzType="primary" [disabled]="!profileForm.valid">
          <span nz-icon nzType="save" nzTheme="outline" class="icon-lg"></span>
          {{ 'profil.buttonSave' | translate }}</button>
      </nz-form-control>
    </nz-form-item>
  </form>
</nz-card>

<div id="logout-section">
  <nz-divider></nz-divider>
  <button nz-button nzType="default" nzDanger nzGhost (click)="logout()">
    <span nz-icon nzType="logout" nzTheme="outline" class="icon-lg"></span>
    <span> {{ 'profil.disconnected' | translate }}</span>
  </button>
</div>


<ng-template #preferredEmailErrorTemplate let-control>
  <ng-container *ngIf="control.errors as errors">
    <div *ngIf="errors['required']; else checkWhitespace">
      {{ 'profil.labelEmailRequired' | translate }}
    </div>
    <ng-template #checkWhitespace>
      <div *ngIf="errors['whitespace']; else checkEmail">
        {{ 'profil.labelEmailWhitespace' | translate }}
      </div>
    </ng-template>
    <ng-template #checkEmail>
      <div *ngIf="errors['email']; else checkDomain">
        {{ 'profil.labelEmailValid' | translate }}
      </div>
    </ng-template>
    <ng-template #checkDomain>
      <div *ngIf="errors['notValidDomain']">
        {{ 'profil.labelEmailDomain' | translate }}
      </div>
    </ng-template>
  </ng-container>
</ng-template>